/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _style11 = require("antd/lib/icon/style");

var _icon = require("antd/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _style12 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _style13 = require("antd/lib/transfer/style");

var _transfer = require("antd/lib/transfer");

var _transfer2 = _interopRequireDefault(_transfer);

var _style14 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _style15 = require("antd/lib/upload/style");

var _upload = require("antd/lib/upload");

var _upload2 = _interopRequireDefault(_upload);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _style16 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style17 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _style18 = require("antd/lib/radio/style");

var _radio = require("antd/lib/radio");

var _radio2 = _interopRequireDefault(_radio);

var _style19 = require("antd/lib/select/style");

var _select = require("antd/lib/select");

var _select2 = _interopRequireDefault(_select);

var _style20 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _config = require("util/config");

var _tool = require("util/tool");

var _premissionAuth = require("util/premissionAuth");

require("./index.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;
var RadioGroup = _radio2.default.Group;
var TextArea = _input2.default.TextArea;

// import { CombineLatestOperator } from "rxjs/operators/combineLatest";
var _ref2 = (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_icon2.default, {
    type: "plus"
}), (0, _jsx3.default)("div", {
    className: "ant-upload-text"
}, void 0, "\u4E0A\u4F20\u56FE\u7247"));

var _ref3 = (0, _jsx3.default)(_input2.default, {});

var _ref4 = (0, _jsx3.default)(_input2.default, {});

var _ref5 = (0, _jsx3.default)(_input2.default, {});

var _ref6 = (0, _jsx3.default)(_input2.default, {});

var Main = function (_Component) {
    (0, _inherits3.default)(Main, _Component);

    function Main(props, context) {
        (0, _classCallCheck3.default)(this, Main);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handlePreview = function (file) {
            _this.setState({
                previewImage: file.url || file.thumbUrl,
                previewVisible: true
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            _this.setState({ fileList: fileList });
            if (fileList.length && fileList[0].response) {
                var res = fileList[0].response;
                var isJPG = fileList[0].type === 'image/jpeg';
                var isPNG = fileList[0].type === 'image/png';
                var isBMP = fileList[0].type === 'image/bmp';
                var isGIF = fileList[0].type === 'image/gif';
                var isWEBP = fileList[0].type === 'image/webp';
                var isPic = isJPG || isPNG || isBMP || isGIF || isWEBP;
                if (!isPic) {
                    _message2.default.error('只能上传图片');
                    _this.setState({ fileList: [] });
                    return false;
                }
                if (res) {
                    if (res.status == 1) {
                        _this.props.initInfo.pictureId = res.data[0];
                    } else {
                        _message2.default.error("图片上传失败");
                        _this.setState({ fileList: [] });
                    }
                }
            }
        };

        _this.handleChangeSelect = function (nextTargetKeys, direction, moveKeys) {
            _this.setState({ targetKeys: nextTargetKeys });
            _this.state.initInfo.partList = nextTargetKeys.length == 0 ? "" : nextTargetKeys;
        };

        _this.handleSelectChangeBj = function (sourceSelectedKeys, targetSelectedKeys) {
            _this.setState({
                selectedKeys: [].concat((0, _toConsumableArray3.default)(sourceSelectedKeys), (0, _toConsumableArray3.default)(targetSelectedKeys))
            });
        };

        _this.state = (0, _extends3.default)({
            targetKeys: []
        }, _this.props, {
            bjvalidateStatus: '',
            bjhelp: '',
            fileList: [],
            DeviceTypeList: [],
            DeviceypeNum: '',
            TDeviceype: '',
            typeList: []
        });
        return _this;
    }

    (0, _createClass3.default)(Main, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.getDeviceTypeList();
            this.getAllPart();
            this.getProductDetail();
            this.queryDeviceTypeList();
        }
        // 获取设备类型列表

    }, {
        key: "getDeviceTypeList",
        value: function getDeviceTypeList() {
            var _this2 = this;

            (0, _tool.http)(_config.apiJson.getDeviceTypeList, {}).then(function (res) {
                console.log(res);
                var arry = [];
                for (var item in res) {
                    arry.push({
                        key: item,
                        value: res[item]
                    });
                }
                _this2.setState({
                    DeviceTypeList: arry
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
                _message2.default.error(msg);
            });
        }
        // 拉取部件

    }, {
        key: "getAllPart",
        value: function getAllPart() {
            var _this3 = this;

            (0, _tool.http)(_config.apiJson.getAllPart).then(function (req) {
                _this3.setState({
                    list: req.map(function (mp) {
                        return {
                            key: mp.id,
                            title: mp.partName,
                            description: mp.partName
                        };
                    })
                });
            });
        }
        // 得到 url

    }, {
        key: "getProductDetail",
        value: function getProductDetail() {
            var _this4 = this;

            var that = this;
            this.props.params.id && (0, _tool.http)(_config.apiJson.getProductDetail, { productId: this.props.params.id }).then(function (data) {
                var imgUrl = _config.target + data.pictureUrl;
                var fileList = [{
                    uid: -100,
                    url: imgUrl || '',
                    thumbUrl: imgUrl
                }];
                that.setState({
                    fileList: fileList
                });
                _this4.setState({
                    initInfo: (0, _assign2.default)(data)
                });
                // 这里是 穿梭框已选中的id集合
                _this4.setState({
                    targetKeys: data.partInfoVoList.map(function (mp) {
                        return mp.id;
                    })
                });
            });
        }
        // 获取产品类型

    }, {
        key: "queryDeviceTypeList",
        value: function queryDeviceTypeList() {
            var _this5 = this;

            (0, _tool.http)(_config.apiJson.queryDeviceTypeList).then(function (res) {
                if (res) {
                    _this5.setState({
                        typeList: res || []
                    });
                }
            });
        }
    }, {
        key: "handleDeviceypeNum",


        // 处理选择 设备类型联动选择设备型号
        value: function handleDeviceypeNum(val) {
            var that = this;
            this.state.DeviceTypeList.forEach(function (item) {
                if (item.key === val) {
                    that.state.initInfo.accessDeviceType = item.value;
                    that.setState({
                        initInfo: that.state.initInfo
                    });
                }
            });
        }
    }, {
        key: "beforeUpload",
        value: function beforeUpload(file, fileList) {
            console.log(file, '---------------1');
        }
        // 选中

        // 赋值

    }, {
        key: "componentDidMount",
        value: function componentDidMount() {}
    }, {
        key: "onRemove",
        value: function onRemove(file) {
            if (file.status === 'removed') {
                this.setState({
                    fileList: []
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this6 = this;

            var _props = this.props,
                form = _props.form,
                deviceTypes = _props.deviceTypes;
            var getFieldDecorator = form.getFieldDecorator;
            var _state = this.state,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage,
                fileList = _state.fileList,
                TDeviceype = _state.TDeviceype,
                initInfo = _state.initInfo;

            console.log(initInfo, '我是图片信息!!');
            var formItemCol = {
                labelCol: { span: 4 },
                wrapperCol: { span: 18, offset: 1 }
            };

            var token = localStorage.getItem("token");
            var ctoken = (0, _premissionAuth.getToken)();

            var headers = {
                Token: ctoken ? ctoken : token
            };

            var uploadButton = _ref2;
            var formObj = {
                businessType: "PRODUCT_IMAGE"
            };

            var options = [];

            deviceTypes.map(function (item) {
                var tpl = (0, _jsx3.default)(Option, {
                    value: item.deviceTypeNumber + ""
                }, item.deviceTypeNumber, item.deviceTypeName);
                options.push(tpl);
            });

            // 部件选择
            return (0, _jsx3.default)("div", {
                className: "cp-form"
            }, void 0, (0, _jsx3.default)(_form2.default, {
                onSubmit: this.props.handleSubmit.bind(this)
            }, void 0, _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u8F66\u578B\u540D\u79F0" }, formItemCol),
                getFieldDecorator("name", {
                    rules: [{ required: true, message: "车型名称不能为空" }],
                    initialValue: initInfo.name
                })(_ref3)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u751F\u4EA7\u5382\u5546" }, formItemCol),
                getFieldDecorator("factoryName", {
                    rules: [{ required: true, message: "生产厂商不能为空" }],
                    initialValue: initInfo.factoryName
                })(_ref4)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u4EA7\u54C1\u4EE3\u7801" }, formItemCol),
                getFieldDecorator("productCode", {
                    rules: [{ required: true, message: "产品代码不能为空" }],
                    initialValue: initInfo.productCode
                })(_ref5)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u8BBE\u5907\u7C7B\u578B" }, formItemCol),
                getFieldDecorator("accessDeviceTypeName", {
                    rules: [{ required: true, message: "设备类型不能为空" }],
                    initialValue: initInfo.accessDeviceTypeName

                })((0, _jsx3.default)(_select2.default, {
                    onChange: this.handleDeviceypeNum.bind(this)
                }, void 0, this.state.DeviceTypeList.map(function (item, index) {
                    return (0, _jsx3.default)(Option, {
                        value: item.key
                    }, index, item.key);
                })))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u8BBE\u5907\u578B\u53F7" }, formItemCol),
                getFieldDecorator("accessDeviceType", {
                    rules: [{ required: true, message: "设备型号不能为空" }],
                    initialValue: initInfo.accessDeviceType
                })((0, _jsx3.default)(_input2.default, {
                    value: TDeviceype,
                    disabled: true
                }))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u8F66\u578B\u4EE3\u7801" }, formItemCol),
                getFieldDecorator("vehModelCode", {
                    rules: [{ required: true, message: "车型代码不能为空" }],
                    initialValue: initInfo.vehModelCode
                })(_ref6)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u8F66\u578B\u56FE\u7247" }, formItemCol),
                getFieldDecorator("pictureId", {
                    rules: [
                    // { required: !initInfo.isEdit, message: "车型图片不能为空" }
                    { required: !(fileList.length > 0), message: "车型图片不能为空" }],
                    initialValue: "" + initInfo.pictureId
                })((0, _jsx3.default)("div", {
                    className: "clearfix"
                }, void 0, (0, _jsx3.default)(_upload2.default, {
                    action: _config.target + _config.apiJson.upload,
                    listType: "picture-card",
                    fileList: fileList,
                    onPreview: this.handlePreview.bind(this),
                    onChange: this.handleChange.bind(this),
                    onRemove: this.onRemove.bind(this),
                    data: formObj,
                    headers: headers,
                    beforeUpload: this.beforeUpload
                }, void 0, fileList.length > 0 ? null : uploadButton), (0, _jsx3.default)(_modal2.default, {
                    visible: previewVisible,
                    footer: null,
                    onCancel: this.handleCancel
                }, void 0, (0, _jsx3.default)("img", {
                    alt: "example",
                    style: { width: "100%" },
                    src: previewImage
                }))))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({ label: "\u90E8\u4EF6\u5217\u8868" }, formItemCol, { validateStatus: this.state.bjvalidateStatus,
                    help: this.state.bjhelp }),
                (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_transfer2.default, {
                    dataSource: this.state.list,
                    titles: ["部件列表", "已绑定"],
                    targetKeys: this.state.targetKeys,
                    selectedKeys: this.state.selectedKeys,
                    onChange: this.handleChangeSelect,
                    onSelectChange: this.handleSelectChangeBj,
                    render: function render(item) {
                        return item.title;
                    }
                }), (0, _jsx3.default)("span", {
                    style: { color: '#3296FA', cursor: 'pointer' },
                    onClick: function onClick() {
                        _this6.props.router.push({
                            pathname: "/parts/index"
                        });
                    }
                }, void 0, "\u90E8\u4EF6\u7BA1\u7406"))
            ), (0, _jsx3.default)(FormItem, {
                label: "\u4EA7\u54C1\u7B80\u4ECB",
                labelCol: { span: 4 },
                wrapperCol: { span: 19, offset: 1 }
            }, void 0, getFieldDecorator("remark", {
                rules: [{ required: false }],
                initialValue: initInfo.remark || ""
            })((0, _jsx3.default)(TextArea, {
                style: { height: "124px" },
                placeholder: "\u7F16\u5199\u8BE5\u4EA7\u54C1\u7684\u7B80\u8981\u8BF4\u660E\uFF0C\u5982\u4EA7\u54C1\u7CFB\u5217\u7279\u70B9\uFF0C\u4E3B\u8981\u51FA\u8D27\u5BF9\u8C61\u7B49\u4FE1\u606F"
            }))), (0, _jsx3.default)(FormItem, {
                wrapperCol: { span: 19, offset: 5 }
            }, void 0, (0, _jsx3.default)("div", {
                className: "btn-group"
            }, void 0, (0, _jsx3.default)(_button2.default, {
                type: "default",
                onClick: this.props.cancleClick.bind(this)
            }, void 0, "\u53D6\u6D88"), (0, _jsx3.default)(_button2.default, {
                type: "primary",
                htmlType: "submit",
                disabled: initInfo.lock
            }, void 0, "\u786E\u5B9A")))));
        }
    }]);
    return Main;
}(_react.Component);

var Fromtpl = _form2.default.create()((0, _reactRouter.withRouter)(Main));

exports.default = Fromtpl;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/edit/form/index.jsx
// module id = 1001
// module chunks = 0